export default {
  getLayoutGuides: async () => {},
}

export const DEFAULT_LAYOUT_GUIDES = { top: 0, bottom: 0 }
